"use client";

import * as React from "react";
import {
  Text,
  SectionCard,
  CardTitle,
  CardDescription,
  Section,
  FormField,
  Input,
} from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsFormField() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Form Field
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            A wrapper component for form inputs with label, hint, and error message support.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/form-field" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Form fields with different states</CardDescription>
            </>
          }
          contentClassName="p-6 space-y-6"
        >
          <FormField htmlFor="email" label="Email" hint="We'll never share your email.">
            <Input id="email" type="email" placeholder="Enter your email" />
          </FormField>

          <FormField htmlFor="username" label="Username" error="Username is already taken">
            <Input id="username" placeholder="Enter username" />
          </FormField>

          <FormField htmlFor="password" label="Password" required>
            <Input id="password" type="password" placeholder="Enter password" />
          </FormField>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">label</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Field label</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">hint</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Helper text</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">error</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 text-muted-foreground">Error message</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">required</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">boolean</td>
                <td className="py-2 text-muted-foreground">Show required indicator</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
